export enum SekoEnvironment {
  PRODUCTION = "production",
  SANDBOX = "sandbox",
}
